import React from 'react';

// Helpers
import { getCookie } from '../helpers/helpers';

// Translations
import translate from './Translate.js';

class SignOut extends React.Component {
  componentWillMount() {
    const { SessionStore } = this.props.store;

    let isAdmin = false;

    if(SessionStore.hasSessionStorage) {
      isAdmin = JSON.parse(sessionStorage.getItem('userData')).role.toLowerCase() === 'administrator';
    } else {
      isAdmin = JSON.parse(getCookie('userData')).role.toLowerCase() === 'administrator';
    }

    if(isAdmin) {
      this.props.store.SessionStore.logout();
    }
  }

  render() {
    const { translation } = this.props;

    return(
      <main tabIndex="0" id="main-content" className="page page--error wrap">
        <div className="panel--brief">
          <div>
            <h1 className="panel__title">{translation.heading}</h1>
            <p>{translation.message}</p>
          </div>
        </div>
      </main>
    )
  }
}

export default translate('SignOut')(SignOut);


// WEBPACK FOOTER //
// ./src/app/components/SignOut.js